<ppl-content-title
  [label]="label"
  [icon]="icon"
  [infoMessage]="infoMessage"
  [labelTemplate]="labelTemplate"
  [actionTemplate]="actionTemplate"
  [flex]="flex"></ppl-content-title>

@if (displayContent) {
  <div class="content">
    <ng-content></ng-content>
  </div>
}
